import '../svg-icon/svg-icon';
import '../input/button-input';
import '../form/search-form';

import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { trapFocus, releaseFocus } from '../../_utils/trap-focus';


@customElement('search-element')
export class SearchElement extends LitElement {

    // Lifecycle Hooks

    firstUpdated() {
        this.classList.add('Search');
		window.addEventListener('keydown', this._handleKeyDown.bind(this));
    }

	disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('keydown', this._handleKeyDown.bind(this));
    }

    // render
    
    render() {
        return html`
            <nav class="Search-nav">
                <button-input
                    type="action"
                    name="lightbox"
                    @click="${ () => { this.close() } }">
                    <div slot="label">
                        <svg-icon name="close"></svg-icon>
                    </div>
                </button-input>
            </nav>
            <div class="Search-body">
                <search-form></search-form>
            </div>
        `;
    }

    createRenderRoot() {
        return this;
    }

    // methods
	_handleKeyDown(e: KeyboardEvent) {
		switch (e.key) {
            case 'Escape':
                this.close();
                break;
        }
	}

    close() {
        this.classList.remove('is-open');
		releaseFocus();
    }
    
    open() {
        this.classList.add('is-open');
		trapFocus(this);
    }

}